import { II18n } from '../../../../models';
import { I18nService } from '../../../../services';

const translations: II18n = {
  es: {
    search: 'Buscar',
  },
  enUS: {
    search: 'Search',
  },
  ptBR: {
    search: 'Pesquisar',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
